import * as React from 'react';
import classnames from 'classnames';
import sanitizeHtml from 'sanitize-html';

import ActionButton from 'components/buttons/action-button/ActionButton';

import './page-heading.scss';

import type { PageAction, PageColor, PageMargin, PageSize, PageWeight } from 'types';

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['br', 'strong', 'div']
};

type Props = {
  color: PageColor,
  size: PageSize,
  weight?: PageWeight,
  margin?: PageMargin,
  customClass: string,
  heading: string,
  message?: string,
  sidenote?: string,
  actionProps?: PageAction,
  rightComponent?: React.ReactNode,
  forwardedRef?: React.RefObject<HTMLDivElement>
};

class PageHeading extends React.PureComponent<Props> {
  static defaultProps = {
    color: 'normal',
    margin: 'normal',
    size: 'medium',
    customClass: ''
  };

  render(): React.ReactNode {
    const {
      heading,
      sidenote,
      message,
      margin,
      color,
      size,
      weight,
      customClass,
      actionProps,
      rightComponent,
      forwardedRef
    } = this.props;

    const headingClassObj = {
      'page-heading': true,
      [`page-heading--color-${color}`]: color,
      [`page-heading--size-${size}`]: size,
      [`page-heading--margin-${String(margin)}`]: margin,
      [customClass]: true,
      [`page-heading--weight-${weight}`]: Boolean(weight)
    };

    const headingClasses = classnames(headingClassObj);

    const messageClasses = classnames({
      'page-heading__message': true,
      [`page-heading__message--size-${size}`]: size
    });

    return (
      <section
        className={headingClasses}
        ref={forwardedRef}
      >
        <div className="page-heading__top">
          <div className="page-heading__heading">
            {heading}
            {
              sidenote &&
                <span className="page-heading__sidenote">- {sidenote}</span>
            }
          </div>
          {
            actionProps &&
              <ActionButton
                link={actionProps.link}
                newTab={actionProps.newTab}
              >
                {actionProps.label}
              </ActionButton>
          }
          {rightComponent}
        </div>
        {
          message &&
            <div
              className={messageClasses}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(message, SANITIZE_HTML_CONFIG) }}
            />
        }
      </section>
    );
  }
}

export default PageHeading;
